module.exports = __webpack_public_path__ + "img/three_single.0aab19a0.png";